
// API base URL - use direct API in all environments for consistency
export const API_BASE_URL = 'https://api.close.com/api/v1';

// Change CORS mode to "cors" for direct API access
export const API_REQUEST_MODE = 'cors' as RequestMode;

// No need for mock data
export const USE_MOCK_DATA = false;

// Define activity types for tracking
export const ACTIVITY_TYPES = {
  CALL: 'call',
  EMAIL: 'email',
  SMS: 'sms',
  MEETING: 'meeting',
  NOTE: 'note'
};

// Define opportunity statuses
export const OPPORTUNITY_STATUSES = {
  WON: 'won',
  LOST: 'lost',
  PENDING: 'pending'
};

// Define lead statuses for tracking
export const LEAD_STATUSES = {
  NEW: 'new',
  QUALIFIED: 'qualified',
  UNQUALIFIED: 'unqualified'
};

// API rate limiting settings based on the Close.com documentation
// @see https://developer.close.com/topics/rate-limits/
export const API_RATE_LIMIT_SETTINGS = {
  // Close.com allows 60 requests per minute per API key
  MAX_REQUESTS_PER_MINUTE: 60,
  // Recommended interval between requests to stay under the limit
  DEFAULT_REQUEST_INTERVAL: 1000, // 1 second
  // Minimum time between requests to the same endpoint (for our own pacing)
  MIN_ENDPOINT_REQUEST_INTERVAL: 5 * 60 * 1000, // 5 minutes
  // Base cooldown time when rate limit is hit
  COOLDOWN_BASE: 60 * 1000, // 1 minute
  // Response header that contains remaining API calls
  RATE_LIMIT_REMAINING_HEADER: 'X-Rate-Limit-Remaining',
  // Response header that contains the rate limit
  RATE_LIMIT_LIMIT_HEADER: 'X-Rate-Limit-Limit',
  // Response header that contains the time when the rate limit resets
  RATE_LIMIT_RESET_HEADER: 'X-Rate-Limit-Reset',
};

// Use the provided test API key
export const TEST_API_KEY = "api_3E4LKuOI6zuHQXFLvlGutE.2RnAnky8ejfSzw5CzTU28k";
export const TEST_EMAIL = "work@hoss-immo.de";
export const TEST_PASSWORD = "HossImmo2025!";
export const TEST_USER_DATA = {
  email: TEST_EMAIL,
  first_name: "Hoss",
  last_name: "Immo"
};
